import React from 'react';
import { StyledParagraph, StyledTitle } from "../CustomAntdComponents/Typography";
import moment from "moment";
import { TitleWrapper } from "./styles";
import { useRoadSearchStore } from '../../store/roadSearch/roadSearchStore';
import { formatSelectedSeats } from '../AvailableBuses/helper';

type Props = {
    operator: BusResultItem,
    bus: AvailableBus,
    label: string
}

const RoadHeading = ({ operator, bus, label }: Props) => {
    const { selectedBusSeat } = useRoadSearchStore();
    
    // Determine the selected seats for this leg (Departure or Return)
    const isReturnLeg = label.toLowerCase() === 'return';
    const legSeats = selectedBusSeat && selectedBusSeat.length > 0
        ? (isReturnLeg && selectedBusSeat.length > 1 ? selectedBusSeat[1] : selectedBusSeat[0])
        : [];

    const formattedDuration = bus.Duration ? bus.Duration.replace(':', ' ') : '';
    const formattedSeats = legSeats && legSeats.length > 0 ? formatSelectedSeats(legSeats) : '';

    const subtitleParts = [
        moment(bus.EstimatedDepartureDate).format('ddd, MMM DD'),
        formattedDuration,
        formattedSeats
    ].filter(Boolean);

    return (
        <TitleWrapper>
            <StyledTitle level={3} style={{ fontWeight: 600, color: '#15162B', marginBottom: '4px' }}>
                {operator.DepartureTerminal} → {operator.ArrivalTerminal}
            </StyledTitle>

            <StyledParagraph size="default" style={{ color: '#72737F' }}>
                {subtitleParts.join(' • ')}
            </StyledParagraph>
        </TitleWrapper>
    );
};

export default RoadHeading;
